<mat-card>
  <mat-card-header class="titreFrm">
    <mat-card-title>LISTE ACTIONS
    <span *ngIf="typeAction == '1'">ADMINISTRATIVE</span>
    <span *ngIf="typeAction == '0'"> FORMATION</span>
  </mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <mat-card>
       
  
    <div>
      <mat-card>
        <div class="displayFlex">
          <div>
              <mat-form-field class="width-130"    appearance="outline" >
                <mat-label>Du</mat-label>
                <input matInput [matDatepicker]="dateDebut" placeholder="Du" [(ngModel)]="date_Debut">
                <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
                <mat-datepicker #dateDebut></mat-datepicker>
              </mat-form-field>
      
              <mat-form-field  class="width-130"   appearance="outline" >
                <mat-label>Au</mat-label>
                <input matInput [matDatepicker]="dateFin" placeholder="Au" [(ngModel)]="date_Fin">
                <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
                <mat-datepicker #dateFin></mat-datepicker>
              </mat-form-field>
      
              
          </div>
          <div style="margin-top: 8px;">
              <!-- <button (click)="facturer()" mat-raised-button class="colorGreen">
                <mat-icon>monetization_on</mat-icon>
                Facturer
              </button> -->
              
              <button [disabled]="!exist" (click)="afficher()" mat-raised-button class="colorGreen">
                <mat-icon>search</mat-icon>
                Filtrer
              </button>
              <button [disabled]="!exist" (click)="modifier('1')" mat-raised-button >
                <mat-icon>add</mat-icon>
                Nouvelle Action
              </button>
              <button [disabled]="!exist" *ngIf="!showButton"  (click)="choisirAction()" mat-raised-button class="colorGreen">
                <mat-icon>mouse</mat-icon>Choisir
              </button>
              <button [disabled]="!exist"  *ngIf="showButton" (click)="modifier('3')" mat-raised-button class="colorGray">
                <mat-icon>import_contacts</mat-icon>
                Consulter
              </button>
              <button [disabled]="!exist" *ngIf="showButton" (click)="modifier('2')" mat-raised-button class="colorBlue">
                <mat-icon>edit</mat-icon>
                Modifier
              </button>
              <button *ngIf="showButton" [disabled]="!exist"  (click)="supprimer()" mat-raised-button class="colorRed">
                <mat-icon>delete</mat-icon>
                Supprimer
              </button>
              <button   type="button" (click)="exportToExcel()" mat-raised-button class="colorGreen"><mat-icon>arrow_downward</mat-icon>Export Excel</button>
          </div>
        </div>
      </mat-card>
      <br>
      <app-avt-listes [api]="generalService.api" #listeComponen [showFilter]="true" [heightTable]="'500'" [dataSourceBrut]="[]" [displayedColumnsBrut]="column" ></app-avt-listes>
    </div>
      </mat-card>
    
  </mat-card-content>
</mat-card>